export default {"src":"/_next/static/media/pringles.c6a18a46.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};